import { Injectable } from '@angular/core';
import { MainService } from '../main/main.service';
import { environment } from "../../../environments/environment";

// import { MainService } from '../main.service';
declare var Stripe: any;

@Injectable({
  providedIn: 'root'
})
export class StripeService {
  public stripe: any;
  public elements: any;
  public paymentElement: any;
  public addressElement: any;
  public paymentRequest: any;
  public prButton: any;
  private paymentData: any;
  setup_intent_secret: any;
  openModal: string = '';
  closeModal = false;
  constructor(
    public _mainservice: MainService
  ) {
    this._mainservice.stripe_publish_key$.subscribe((key) => {
      if (key && !this.stripe) {
        this.stripe = Stripe(key);
      }
    });
  }

  private async setupElements(clientSecret: string): Promise<void> {
    this.elements = await this.stripe.elements({
      clientSecret,
      appearance: this.getAppearanceOptions(),
    });
  }

  public async createAddressElement(addressId?): Promise<void> {
    try {
      if (!this.elements) {
        throw new Error('Stripe elements are not initialized.');
      }
      return new Promise((resolve, reject) => {
        try {
          this.addressElement = this.elements.create('address', {
            mode: 'billing',
            fields: {
              line1: 'auto',
              line2: 'auto',
              city: 'auto',
              state: 'auto',
              postal_code: 'auto',
              country: 'auto',
            },
            autocomplete: {
              mode: 'google_maps_api',
              apiKey: environment.google_places_key,
            },
            blockPoBox: true,
            display: { name: 'full' },
            allowedCountries: ['US', 'CA'],
            defaultValues: {
              address: {
                country: 'US'
              }
            }
          });

          let id = addressId ? `#${addressId}` : '#address-element';
          this.addressElement.mount(id);
          resolve();
        } catch (error) {
          console.error('Error creating address element:', error);
          reject(error);
        }
      });
    } catch (error) {
      console.error('Error in createAddressElement:', error);
      throw error;
    }
  }


  private async createPaymentRequestButton(clientSecret: string, paymentData): Promise<void> {
    try {
      // Create the payment request object
      this.paymentRequest = this.stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Total',
          amount: paymentData.amount || 0, // Example amount in cents
        },
        requestPayerName: true,
        requestPayerEmail: true,
        requestPayerPhone: true,
        requestShipping: false,
        supportedPaymentMethods: [
          { supportedMethods: 'card' },
          { supportedMethods: 'google_pay' },
          { supportedMethods: 'apple_pay' },
        ],
      });

      // Check for Payment Request button availability
      const result = await this.paymentRequest.canMakePayment();
      if (result) {
        // Create and mount the Payment Request Button
        this.prButton = this.elements.create('paymentRequestButton', {
          paymentRequest: this.paymentRequest,
          style: {
            paymentRequestButton: {
              theme: 'dark',
              height: '64px',
              type: 'default', // Options: 'buy', 'donate', etc.
            },
          },
        });
        this.prButton.mount('#payment-request-button');
      } else {
        console.log('Payment Request button not available. Payment method not supported on this browser/device.');
      }

      // Handle Payment Request submission
      this.paymentRequest.on('paymentmethod', async (ev: any) => {
        try {
          const { error, paymentIntent } = await this.stripe.confirmPayment({
            elements: this.elements,
            confirmParams: {
              return_url: `${window.location.origin}/payment-confirmation`,
            },
          });

          if (error) {
            console.error('Payment confirmation error:', error);
            ev.complete('fail');
          } else {
            ev.complete('success');
            if (paymentIntent.status === 'requires_action') {
              await this.stripe.confirmCardPayment(clientSecret);
            } else {
              console.log('Payment successful');
            }
          }
        } catch (error) {
          console.error('Error handling payment request submission:', error);
          ev.complete('fail');
        }
      });
    } catch (error) {
      console.error('Error creating payment request button:', error);
    }
  }



  // 3DS handling function for 2-way authetication
  async confirm3DSCharge(clientSecret: string, paymentMethodId: any): Promise<boolean> {
    try {
      const { error, paymentIntent } = await this.stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId, // Use the saved PaymentMethod ID here
      });

      if (error) {
        this._mainservice.customPopups("We are unable to authenticate your payment method. Please choose a different payment method and try again.", 1);
        return false;
      }

      if (paymentIntent) {
        switch (paymentIntent.status) {
          case 'succeeded':
            return true;

          case 'requires_action':
            this._mainservice.customPopups("Further action required", 2);
            return false;

          default:
            this._mainservice.customPopups(`Unexpected payment status: ${paymentIntent.status}`, 2);
            return false;
        }
      }
      return false;

    } catch (error) {
      this._mainservice.customPopups("We are unable to authenticate your payment method. Please choose a different payment method and try again", 1);
      return false;
    }
  }

  async GetClientSecret(): Promise<string> {
    let data: {
      access_token: string;
      patient_id?: string
      doctor_id?: string
    } = {
      access_token: localStorage.getItem("token") || '',
    };

    if (this.paymentData && this.paymentData.patient_id) {
      data.patient_id = this.paymentData.patient_id;
    }

    if (this.paymentData && this.paymentData.doctor_id) {
      data.doctor_id = this.paymentData.doctor_id;
    }

    return new Promise((resolve, reject) => {
      this._mainservice.api(data, 'create_setup_intent', 'post').subscribe(
        (response: any) => {
          if (response.is_error) {
            const errorMessage = response.override_text || response.err || 'An error occurred';
            this._mainservice.customPopups(errorMessage, response.is_error);
            return reject("");
          }
          this.setup_intent_secret = response.result || '';
          resolve(this.setup_intent_secret.setup_intent_secret);
        }
      );
    });
  }

  public async createStripeElement(paymentData: any, paymentId?, addressId?): Promise<void> {
    try {
      this.paymentData = paymentData;
      let clientSecret = await this.GetClientSecret();
      await this.setupElements(clientSecret);
      if (this.paymentData.isMountAddress) {
        await this.createAddressElement(addressId);
      }
      await this.mountPaymentElement(paymentId);
      await this.createPaymentRequestButton(clientSecret, paymentData);
    } catch (error) {
      console.error('Error creating Stripe element:', error);
    }
  }

  private mountPaymentElement(paymentId): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        if (!this.elements) {
          throw new Error('Stripe elements are not initialized.');
        }

        let options = {
          layout: {
            type: 'tabs',
            defaultCollapsed: false,
          },
          hidePostalCode: true,
        };
        this.paymentElement = this.elements.create('card', options);

        let id = paymentId ? `#${paymentId}` : '#payment-element';
        this.paymentElement.mount(id);
        resolve();
      } catch (error) {
        console.error('Error mounting the payment element:', error);
        reject(error);
      }
    });
  }



  unmountCard() {
    setTimeout(() => {
      if (this.closeModal) {
        this.openModal = '';
        this.closeModal = false;
      }
    }, 300)

  }

  UnmountStripe() {
    if(this.paymentElement)
    this.paymentElement.unmount()
    if(this.addressElement)
    this.addressElement.unmount()
  }


  private getAppearanceOptions() {
    // if (this.paymentData.appearance == 'finance-flow') {
    //   return {
    //     theme: 'accordion',
    //     labels: 'floating',
    //     variables: {
    //       spacingUnit: '0',
    //       borderRadius: '10px',
    //       gridColumnSpacing: '5px',
    //       gridRowSpacing: '8px',
    //       fontFamily: "'Inter', sans-serif",
    //     },
    //     cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap',
    //     rules: {
    //       '.Input': {
    //         padding: '.5rem 1rem',
    //         height: '56px',
    //         fontSize: '17px',
    //         color: '#000000',
    //         fontWeight: '700',
    //         borderColor: '#B6BCC4',
    //         borderWidth: '1px',
    //       },
    //       '.Input:focus': {
    //         borderColor: '#1581E5',
    //         boxShadow: '0px 4px 10px rgba(21, 129, 229, 0.2)',
    //       },
    //       '.Label': {
    //         color: 'rgb(122, 132, 141)',
    //         fontSize: '16px',
    //       },
    //       '.Input:focus + .Label': {
    //         fontSize: '12px',
    //       },
    //       '.Error': {
    //         margin: '10px 0'
    //       }
    //     },
    //   };
    // } else {
    return {
      theme: 'accordion',
      labels: '',
    }
    // }
  }


}
